const transfers = {
  transfer: "Transferir", // translated
  transfers: "Transferências", // translated
  dateAndTime: "Data e hora", // translated
  transferFrom: "Transferir de", // translated
  duration: "Duração", // translated
  numOfPersons: "Número de pessoas", // translated
  baggageAllowance: "Franquia de bagagem", // translated
  small: "Pequeno", // translated
  big: "Grande", // translated
  provider: "Fornecedor", // translated
  vehicle: "Veículo", // translated
  distance: "Distância", // translated
  price: "Preço", // translated
  inboundJourney: "Jornada de entrada", // translated
  outboundJourney: "Jornada de Saída", // translated
  arrivalTime: "Tempo de chegada", // translated
  flightDetails: "Detalhes do vôo", // translated
  inboundPickupDate: "Data de retirada de entrada", // translated
  outboundPickupDate: "Data de retirada de saída", // translated
  travelInfo: "Informações de viagem", // translated
  flightsInfo: "Informações sobre voos", // translated
  airportYouAreFlyingFrom: "Aeroporto de onde você está voando", // translated
  airportYouAreFlyingTo: "Aeroporto para o qual você está voando", // translated
  inboundFlightNumber: "Número do voo de entrada", // translated
  outboundFlightNumber: "Número do voo de saída", // translated
  inboundAirlineName: "Nome da companhia aérea de entrada", // translated
  outboundAirlineName: "Nome da companhia aérea de saída", // translated
  tripMode: "Modo de viagem", // translated
  airportToPoint: "Aeroporto para apontar", // translated
  pointToAirport: "Apontar para o aeroporto", // translated
  roundTrip: "Ida e volta", // translated
  destinationPoint: "Ponto de destino", // translated
  originPoint: "Ponto de Origem", // translated
  transferType: "Tipo de transferência", // translated
  min: "Mínimo", // translated
  max: "Máx.", // translated
  pieces: "Peças", // translated
  cancelationIs: "o cancelamento é", // translated
};


export default transfers;
